import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeValue } from '../../../redux/actions/chickenDashAction';
import { SingleSelectFilter } from '../../../components/Filters';
import { useChartInterval } from '../../../hooks/useChartInterval';
import useIsMobile from '../../../hooks/useIsMobile';
import useFirst from '../../../hooks/useFirst';

const DashboardToolbarInterval = () => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const isFirstRender = useFirst();
  
  const startDate = useSelector(state => state.chickenDashboard.startDate);
  const endDate = useSelector(state => state.chickenDashboard.endDate);
  const timeInterval = useSelector(state => state.chickenDashboard.timeInterval);
  const interval = useSelector(state => state.chickenDashboard.interval);
  
  const changeStoreValue = useCallback((...params) => {
    dispatch(changeValue(...params));
  }, [dispatch]);
  
  const intervalState = useChartInterval(
    startDate,
    endDate,
    timeInterval,
    value => changeStoreValue('interval', value),
    !isMobile || isFirstRender
  );
  
  return (
    <SingleSelectFilter
      title="Interval"
      name="interval"
      options={intervalState}
      value={interval}
      onChange={changeStoreValue}
    />
  );
};

export default memo(DashboardToolbarInterval);